/* ══════════════════════════════════════════════════════════════════════════
   KITSTERS - SHARED MEDIA LIGHTBOX (zoom)
   --------------------------------------------------------------------------
   Extracted from kitsters-product.js on 2026-08-17, unchanged in behaviour,
   because the owner asked for the same zoom on the Magic Hour product page:
   "Every image can be zoom, just like other product page. Also make sure to
   handle the video also." Copying it would have been a second implementation
   to keep in step - the drift §10.75 is about - so both PDPs load this file
   and the only per-page part is the GALLERIES table below.

   Loaded by the two PDP sections, not by theme.liquid: no other page needs it.

   Delegated on `document` so zoom ALWAYS works regardless of DOM/load order,
   lazy images, or slides being re-rendered by a variant change.

   VIDEO (§10.57, owner-reported 2026-08-03 "in zoom we can't able to play
   video"): a gallery slide can be a `video` (video_tag) or an `iframe`
   (external_video_tag), NOT only an `img`. The original looked up
   `slide.querySelector('img')`, found nothing on a video slide, and fell
   through to the FIRST image in the gallery - so zooming a video silently
   opened a small, unrelated still: no error, no empty state, just the wrong
   media and nothing to play. A fallback that returns DIFFERENT content instead
   of nothing is the trap; it reads as a rendering bug rather than a missing
   capability.

   So the overlay mounts a CLONE of whatever the active slide holds. A clone,
   not the node itself, so the inline player keeps its own state and the DOM
   goes back untouched on close - moving the original would leave a hole in the
   carousel and reset playback.
   ══════════════════════════════════════════════════════════════════════════ */
(function() {
  var overlay = document.createElement('div');
  overlay.className = 'kp-lightbox';
  overlay.setAttribute('aria-hidden', 'true');
  overlay.innerHTML =
    '<button type="button" class="kp-lightbox__close" aria-label="Close">✕</button>' +
    '<img class="kp-lightbox__img" alt="">';
  document.body.appendChild(overlay);

  var lbImg = overlay.querySelector('.kp-lightbox__img');
  var closeBtn = overlay.querySelector('.kp-lightbox__close');
  var lastFocus = null;
  var mounted = null;   // cloned <video>/<iframe> currently in the overlay

  function unmount() {
    if (!mounted) return;
    if (mounted.tagName === 'VIDEO') { try { mounted.pause(); } catch (e) {} }
    // Dropping an iframe's src stops a remote player that would otherwise keep
    // playing audio behind the closed overlay.
    mounted.removeAttribute('src');
    if (mounted.parentNode) mounted.parentNode.removeChild(mounted);
    mounted = null;
  }

  function openLb(src, alt) {
    if (!src) return;
    unmount();
    lbImg.hidden = false;
    lbImg.src = src;
    lbImg.alt = alt || '';
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  /* Mount a clone of a <video>/<iframe> slide at lightbox size. */
  function openLbNode(node) {
    if (!node) return;
    unmount();
    lbImg.removeAttribute('src');
    lbImg.hidden = true;               // keep the img out of the flex centring

    var clone = node.cloneNode(true);
    clone.classList.remove('kp-gallery__img');
    clone.className += ' kp-lightbox__media';
    clone.removeAttribute('width');
    clone.removeAttribute('height');
    clone.removeAttribute('loading');

    if (clone.tagName === 'VIDEO') {
      clone.controls = true;           // the whole point - give them a player
      clone.setAttribute('playsinline', '');
      clone.loop = false;
      // Autoplay is only permitted while muted, so start muted and leave the
      // controls to unmute. Carrying currentTime over means "zoom" resumes
      // where the inline player was rather than restarting.
      clone.muted = true;
      try { if (!isNaN(node.currentTime)) clone.currentTime = node.currentTime; } catch (e) {}
    } else if (clone.tagName === 'IFRAME') {
      // External players (YouTube/Vimeo) need explicit permission to go
      // fullscreen once they are in our overlay.
      clone.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; picture-in-picture');
      clone.setAttribute('allowfullscreen', '');
    }

    overlay.appendChild(clone);
    mounted = clone;

    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();

    // play() rejects if the policy still refuses; the controls are already
    // there, so a rejection degrades to "press play" rather than to nothing.
    if (clone.tagName === 'VIDEO') {
      var p = clone.play();
      if (p && p.catch) p.catch(function () {});
    }
  }

  /* ── The two galleries this serves ──────────────────────────────────────
     Each entry says how to find the gallery's container, its zoom button, and
     WHICH slide is currently showing - the only thing the two markup shapes
     disagree about. The retail PDP tracks the active index on its dots/thumbs;
     the Magic Hour PDP marks the active slide itself with `.is-on`. Adding a
     third gallery is one more row here, not another copy of this file. */
  var GALLERIES = [
    {
      main: '.kp-gallery__main',
      activeSlide: function (main) {
        var active = document.querySelector('.kp-gallery__dot.active, .kp-thumb.active');
        var idx = active ? parseInt(active.getAttribute('data-index'), 10) : 0;
        return main.querySelector('.kp-gallery__slide[data-index="' + idx + '"]');
      }
    },
    {
      main: '.kmhp__gallery-main',
      activeSlide: function (main) {
        return main.querySelector('[data-gallery-slide].is-on') ||
               main.querySelector('[data-gallery-slide]');
      }
    }
  ];

  /* The gallery config whose container holds `el`, or the first one present. */
  function galleryFor(el) {
    for (var i = 0; i < GALLERIES.length; i++) {
      var main = el ? el.closest(GALLERIES[i].main) : document.querySelector(GALLERIES[i].main);
      if (main) return { cfg: GALLERIES[i], main: main };
    }
    return null;
  }

  /* The active slide's own media node, whatever type it is. */
  function activeSlideMedia(ctx) {
    if (!ctx) return null;
    var slide = ctx.cfg.activeSlide(ctx.main);
    return slide ? slide.querySelector('video, iframe') : null;
  }
  function closeLb() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    lbImg.removeAttribute('src');
    unmount();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // The still currently on screen, for the zoom button.
  function activeGalleryImg(ctx) {
    if (!ctx) return null;
    var slide = ctx.cfg.activeSlide(ctx.main);
    var img = slide ? (slide.matches('img') ? slide : slide.querySelector('img')) : null;
    // The fallback is reached only for a STILL slide with no img of its own - a
    // video slide is handled by activeSlideMedia() before we ever get here.
    // Without that ordering this returns the gallery's first image, which is
    // the bug reported 2026-08-03 (§10.57).
    return img || ctx.main.querySelector('img');
  }

  /* Zoom the active slide, whatever media type it is. */
  function zoomActiveSlide(focusEl) {
    var ctx = galleryFor(focusEl);
    var node = activeSlideMedia(ctx);
    if (node) { lastFocus = focusEl; openLbNode(node); return; }
    var img = activeGalleryImg(ctx);
    if (img) { lastFocus = focusEl; openLb(img.currentSrc || img.src, img.alt); }
  }

  document.addEventListener('click', function(e) {
    // Controls that belong to the gallery navigate, they do not zoom: the
    // retail prev/next arrows and the Magic Hour thumbnail buttons. The thumbs
    // sit outside `.kmhp__gallery-main` so they would not be caught by the
    // click-anywhere branch anyway - listed here so the intent is explicit and
    // survives a markup move.
    if (e.target.closest('.kp-gallery__btn, [data-gallery-thumb], .kp-thumb')) return;

    // explicit "view full image" button on the hero card
    var zoomBtn = e.target.closest('.kp-gallery__zoom');   // both galleries use this class
    if (zoomBtn) {
      e.preventDefault();
      zoomActiveSlide(zoomBtn);
      return;
    }

    // An inline player owns its own clicks - play/pause, seek, volume,
    // fullscreen. Swallowing them into the lightbox is what made the inline
    // video unplayable too, since every click on it opened the overlay instead.
    if (e.target.closest('video, iframe')) return;

    // click ANYWHERE on the hero card (image, padding, sticker) → zoom the
    // active slide. Both galleries, same behaviour.
    var mainCard = e.target.closest('.kp-gallery__main, .kmhp__gallery-main');
    if (mainCard) {
      // A gallery with no photos yet shows a placeholder, and zooming a
      // placeholder is not a feature - bail rather than open an empty overlay.
      if (!mainCard.querySelector('img, video, iframe')) return;
      e.preventDefault();
      zoomActiveSlide(mainCard);
      return;
    }

    // other zoomable images (UGC tile, review photo, photo-marquee cell).
    // `.kpm__img` is the shared photo marquee (snippets/kitsters-photo-marquee
    // .liquid) when its caller passes `zoom: true` - Magic Hour's "More from
    // this hour" band today. It is one more selector here rather than a second
    // lightbox, which is the whole point of this file existing.
    var img = e.target.closest('.kp-ugc-grid__img, .kp-rr__photo, .kpm__img');
    if (img && img.tagName === 'IMG') {
      e.preventDefault();
      lastFocus = img;
      /* `data-zoom-src` wins when the thumbnail carries one. `currentSrc` is
         the source the browser picked for the THUMBNAIL's box, so zooming a
         260px card gave the overlay a 560w file to paint at ~570 CSS px -
         adequate at 1x, soft on any 2x display. Widening the card's own srcset
         cannot fix that: currentSrc is chosen from the displayed size, so a
         bigger candidate would never be picked. Optional, so the UGC tile and
         the review photo keep their existing behaviour untouched. */
      openLb(img.getAttribute('data-zoom-src') || img.currentSrc || img.src, img.alt);
    }
  });

  overlay.addEventListener('click', function(e) {
    if (e.target === overlay || e.target === closeBtn) closeLb();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeLb();
  });
})();
